export const SET_ALL_NOTICES = "Setzt alle notice";
export const SET_CURRENT_NOTICE = "Setzt den/das aktuelle notice";
export const SET_LOCK = "Setze das Notice Lock";
